export const columns = [
    {
        id: 2,
        name: "Drax Executive",
        ldPermissions: ["Adapt"],
        pacePermissions: ["Executive Evaluation"],
        usersCount: 3,
        crmId: 1,
        createdOn: "2024-07-12",
    },
    {
        id: 3,
        name: "Rowan Group",
        ldPermissions: ["Adapt"],
        pacePermissions: ["Executive Evaluation"],
        usersCount: 4,
        crmId: 2,
        createdOn: "2024-07-12",
    },
];

export const tableHeaderConfig: {
    id: string | number;
    name: string;
    isHidable: boolean;
    isSortable?: boolean;
    isSortableByBestMatch?: boolean;
    isSortableByDate?: boolean;
    sort?: { isSortableByBestMatch?: boolean; sortBy?: "date" | "a-z" };
    isHidden?: boolean;
    sx: React.CSSProperties;
}[] = [
    {
        id: "name",
        name: "User",
        isHidable: false,
        isSortable: true,
        sort: { isSortableByBestMatch: false, sortBy: "a-z" },
        sx: { width: 250 },
    },
    {
        id: "role",
        name: "Role",
        isSortable: false,
        isHidable: true,
        isHidden: false,
        sx: { width: 180 },
    },
    {
        id: "jobTitle",
        name: "Job Title",
        isSortable: false,
        isHidable: true,
        isHidden: false,
        sx: { width: 200 },
    },
    {
        id: "last_active_datetime",
        name: "Last Active",
        isSortable: true,
        isHidable: true,
        isHidden: false,
        sort: { isSortableByBestMatch: false, sortBy: "date" },
        sx: { width: 130 },
    },
    {
        id: "team",
        name: "Team",
        isSortable: false,
        isHidable: true,
        isHidden: false,
        sx: { maxWidth: "1px" },
    },
];
